import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=42d579f2&scoped=true&"
import script from "./BlogArticle.vue?vue&type=script&lang=ts&"
export * from "./BlogArticle.vue?vue&type=script&lang=ts&"
import style0 from "./BlogArticle.vue?vue&type=style&index=0&id=42d579f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d579f2",
  null
  
)

export default component.exports